module.exports = __webpack_public_path__ + "static/media/login-register.5cb0c7f4.jpg";